// 成为经销商
<template>
  <div class="main">
    <div class="head">
      <myheadert></myheadert>
      <img src="~@/assets/aboutMe_img/u6086-4.png" class="title">
    </div>
    <div class="middle">
      <div class="location">
        <img src="~@/assets/common_img/house.png">
        <span class="place">您的位置：&nbsp;<span @click="goHome">主页</span>＞加入我们＞成为经销商</span>
      </div>
      <div class="lead">
        <ul>
          <li><a href="#/hiring">招贤纳士</a></li>
          <li  class="lead_two"><a href="#/agency">成为经销商</a></li>
        </ul>
      </div>
      <div class="line"></div>
    </div>
    <div class="agency">
      <!-- <form action="agency.php"  method="post"> -->
        <p class="applyFor">申请成为经销商</p>
        <ul class="apply">
          <li>&nbsp;&nbsp;企业名称：<input type="text" name="Cname" id="Cname" v-on:onblur="checkCname()"></li>
          <li>&nbsp;&nbsp;联系人：<input type="text" name="contacts" id="contacts"></li>
          <li>&nbsp;&nbsp;电话：<input type="tel" name="phone" id="phone"></li>
          <li>&nbsp;&nbsp;邮箱：<input type="email" name="Cemail" id="Cemail"></li>
          <li>&nbsp;&nbsp;您的客户类型：<input type="radio" value="企业" name="type" id="business" checked>企业<input type="radio" value="个人" name="type" id="person">个人</li>
        </ul>
        <textarea cols="74" rows="4" placeholder="请提交您的留言,我们将安排专业服务人员为您提供答疑或帮助:" name="messsage" id="message"></textarea>
        <button class="agency-button" @click="addAgency">提交</button>
      <!-- </form> -->
    </div>
    <div style="height:30px"></div>
  </div>
</template>
<script>
import axios from 'axios'
import qs from 'qs'
export default{
  name: 'agency',
  data () {
    return {
    }
  },
  mounted () {
    // this.addAgency()
    // this.checkCname()
  },
  methods: {
    goHome () {
      this.$router.push(
        {
          path: '/'
        }
      )
      location.reload()
    },
    addAgency () {
      var Cname = document.getElementById('Cname').value
      var contacts = document.getElementById('contacts').value
      var phone = document.getElementById('phone').value
      var Cemail = document.getElementById('Cemail').value
      let type = document.getElementsByName('type')
      for (var i = 0; i < type.length; i++) {
        if (type[i].checked) {
          var checkedVal = type[i].value
        }
      }
      var Cmessage = document.getElementById('message').value
      if (Cname === '' || contacts === '' || phone === '' || Cemail === '' || Cmessage === '') {
        alert('请填写完整信息')
      } else if (!(/^1[34578]\d{9}$/.test(phone))) {
        alert('电话格式不正确')
      } else if (!(/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(Cemail))) {
        alert('邮箱格式不正确')
      } else {
        let formdata = {
          Cname: Cname,
          contacts: contacts,
          phone: phone,
          Cemail: Cemail,
          Cmessage: Cmessage
        }
        axios({
          method: 'post',
          url: 'http://' + this.global.url + ':8081/api/user/agencyEmail',
          data: qs.stringify(formdata)
        })
          .then(function (res) {
            console.log(res.data)
          })
          .catch(function (res) {
            console.log(res.data)
          })
        this.$axios.post('http://' + this.global.url + ':8081/api/user/addAgency', this.$qs.stringify({
          Cname: Cname,
          contacts: contacts,
          phone: phone,
          Cemail: Cemail,
          type: checkedVal,
          Cmessage: Cmessage
        }))
          .then(function (res) {
            console.log(res.data)
          })
          .catch(function (res) {
            console.log(res)
          })
        alert('提交成功')
      }
    }
  }
}
</script>
<style scoped>
@media screen and (min-width: 1500px){
  /* 顶部 */
.head{
  width: 100%;
  height: 253px;
  background-image: url('~@/assets/addMe_img/01871-crop-u7840.jpg');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.title{
  width: 900px;
  margin-top: 25px;
}
/* 位置 */
.location{
  width: auto;
  height: 27px;
  /* border: 1px red solid; */
  margin-top: 1%;
  margin-left: 14.5%;
  font-size: 18px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 关于我们-导航 */
.lead{
  margin-left: 61%;
  margin-bottom: 0;
}
.lead ul{
  list-style: none;
}
.lead ul li{
  width: 20%;
  height: 27px;
  float: left;
  text-align: center;
  line-height: 27px;
}
.lead a{
  text-decoration: none;
  color: black;
  font-family: "黑体";
  font-size: 15px;
}
.lead_two{
  background-color: #F15A24;
}
/* 线 */
.line{
  width: 100%;
  height: 1px;
  background-color: black;
  margin-top: 26px;
}
/* 申请经销商 */
.agency{
  width: 34%;
  height: 620px;
  border: 1px black solid;
  margin: 0 auto;
  margin-top: 20px;
}
ul{
  list-style: none;
  margin-left: 5%;
}
.apply li{
  width: 90%;
  height: 70px;
  border-radius: 10px;
  border: 1px black solid;
  margin-top: 10px;
  font-size: 16px;
  color: rgb(158, 154, 154);
  line-height: 70px;
}
.applyFor{
  font-size: 20px;
  color: rgba(163, 8, 8, 0.829);
  margin-left: 5%;
}
.apply input{
  width: 75%;
  height: 50%;
  border: 0;
}
#business,#person{
  width: 3%;
  margin-left: 15%;
  display: inline-block;
  font-size: 20px;
  position: relative;
  top: 10px;
}
/* .apply textarea{
  border: 0;
} */
.agency-button{
  width: 20%;
  height: 50px;
  background-color: rgba(209, 13, 13, 0.884);
  color: white;
  font-size: 25px;
  margin-left: 40%;
  margin-top: 15px;
  /* box-shadow: none; */
  /* border: none; */
}
.agency textarea{
  width: 85%;
  margin-left: 5%;
  margin-top: 10px;
}
}
@media screen and (min-width: 1200px) and (max-width:1499px){
  /* 顶部 */
.head{
  width: 100%;
  height: 253px;
  background-image: url('~@/assets/addMe_img/01871-crop-u7840.jpg');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.title{
  width: 750px;
  margin-top: 20px;
}
/* 位置 */
.location{
  width: auto;
  height: 27px;
  /* border: 1px red solid; */
  margin-top: -3%;
  margin-left: 14.5%;
  font-size: 18px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 关于我们-导航 */
.lead{
  margin-left: 61%;
  margin-bottom: 0;
}
.lead ul{
  list-style: none;
}
.lead ul li{
  width: 20%;
  height: 27px;
  float: left;
  text-align: center;
  line-height: 27px;
}
.lead a{
  text-decoration: none;
  color: black;
  font-family: "黑体";
  font-size: 15px;
}
.lead_two{
  background-color: #F15A24;
}
/* 线 */
.line{
  width: 100%;
  height: 1px;
  background-color: black;
  margin-top: 26px;
}
/* 申请经销商 */
.agency{
  width: 40%;
  height: 620px;
  border: 1px black solid;
  margin: 0 auto;
  margin-top: 20px;
}
ul{
  list-style: none;
  margin-left: 5%;
}
.apply li{
  width: 90%;
  height: 70px;
  border-radius: 10px;
  border: 1px black solid;
  margin-top: 10px;
  font-size: 16px;
  color: rgb(158, 154, 154);
  line-height: 70px;
}
.applyFor{
  font-size: 20px;
  color: rgba(163, 8, 8, 0.829);
  margin-left: 5%;
}
.apply input{
  width: 75%;
  height: 50%;
  border: 0;
}
#business,#person{
  width: 3%;
  margin-left: 15%;
  display: inline-block;
  font-size: 20px;
  position: relative;
  top: 10px;
}
/* .apply textarea{
  border: 0;
} */
.agency-button{
  width: 20%;
  height: 50px;
  background-color: rgba(209, 13, 13, 0.884);
  color: white;
  font-size: 25px;
  margin-left: 40%;
  margin-top: 15px;
  /* box-shadow: none; */
  /* border: none; */
}
.agency textarea{
  width: 85%;
  margin-left: 5%;
  margin-top: 10px;
}
}
@media screen and (min-width: 960px) and (max-width:1199px){
  /* 顶部 */
.head{
  width: 100%;
  height: 253px;
  background-image: url('~@/assets/addMe_img/01871-crop-u7840.jpg');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.title{
  width: 600px;
  /* margin-left: 20px; */
  margin-top: 10px;
}
/* 位置 */
.location{
  width: auto;
  height: 20px;
  /* border: 1px red solid; */
  margin-top: -6%;
  margin-left: 14.5%;
  font-size: 16px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  width: 3%;
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 关于我们-导航 */
.lead{
  margin-left: 61%;
  margin-bottom: 0;
}
.lead ul{
  list-style: none;
}
.lead ul li{
  width: 25%;
  height: 27px;
  float: left;
  text-align: center;
  line-height: 27px;
}
.lead a{
  text-decoration: none;
  color: black;
  font-family: "黑体";
  font-size: 15px;
}
.lead_two{
  background-color: #F15A24;
}
/* 线 */
.line{
  width: 100%;
  height: 1px;
  background-color: black;
  margin-top: 26px;
}
/* 申请经销商 */
.agency{
  width: 45%;
  height: 620px;
  border: 1px black solid;
  margin: 0 auto;
  margin-top: 20px;
}
ul{
  list-style: none;
  margin-left: 5%;
}
.apply li{
  width: 90%;
  height: 70px;
  border-radius: 10px;
  border: 1px black solid;
  margin-top: 10px;
  font-size: 16px;
  color: rgb(158, 154, 154);
  line-height: 70px;
}
.applyFor{
  font-size: 20px;
  color: rgba(163, 8, 8, 0.829);
  margin-left: 5%;
}
.apply input{
  width: 75%;
  height: 50%;
  border: 0;
}
#business,#person{
  width: 3%;
  margin-left: 15%;
  display: inline-block;
  font-size: 20px;
  position: relative;
  top: 10px;
}
.agency-button{
  width: 20%;
  height: 50px;
  background-color: rgba(209, 13, 13, 0.884);
  color: white;
  font-size: 25px;
  margin-left: 40%;
  margin-top: 15px;
  /* box-shadow: none; */
  /* border: none; */
}
.agency textarea{
  width: 85%;
  margin-left: 5%;
  margin-top: 10px;
}
}
@media screen and (min-width: 768px) and (max-width:959px){
  /* 顶部 */
.head{
  width: 100%;
  height: 253px;
  background-image: url('~@/assets/addMe_img/01871-crop-u7840.jpg');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.title{
  width: 400px;
  /* margin-left: 30px; */
  /* margin-top: 10px; */
}
/* 位置 */
.location{
  width: auto;
  height: 20px;
  /* border: 1px red solid; */
  margin-top: -11%;
  margin-left: 14.5%;
  font-size: 12px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  width: 3%;
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 关于我们-导航 */
.lead{
  margin-left: 61%;
  margin-bottom: 0;
}
.lead ul{
  list-style: none;
}
.lead ul li{
  width: 28%;
  height: 27px;
  float: left;
  text-align: center;
  line-height: 27px;
  /* margin-left: 10px; */
}
.lead a{
  text-decoration: none;
  color: black;
  font-family: "黑体";
  font-size: 15px;
}
.lead_two{
  background-color: #F15A24;
}
/* 线 */
.line{
  width: 100%;
  height: 1px;
  background-color: black;
  margin-top: 26px;
}
/* 申请经销商 */
.agency{
  width: 55%;
  height: 620px;
  border: 1px black solid;
  margin: 0 auto;
  margin-top: 20px;
}
ul{
  list-style: none;
  margin-left: 5%;
}
.apply li{
  width: 90%;
  height: 70px;
  border-radius: 10px;
  border: 1px black solid;
  margin-top: 10px;
  font-size: 16px;
  color: rgb(158, 154, 154);
  line-height: 70px;
}
.applyFor{
  font-size: 20px;
  color: rgba(163, 8, 8, 0.829);
  margin-left: 5%;
}
.apply input{
  width: 70%;
  height: 50%;
  border: 0;
}
#business,#person{
  width: 3%;
  margin-left: 15%;
  display: inline-block;
  font-size: 20px;
  position: relative;
  top: 10px;
}
.agency-button{
  width: 20%;
  height: 50px;
  background-color: rgba(209, 13, 13, 0.884);
  color: white;
  font-size: 25px;
  margin-left: 40%;
  margin-top: 15px;
  /* box-shadow: none; */
  /* border: none; */
}
.agency textarea{
  width: 85%;
  margin-left: 5%;
  margin-top: 10px;
}
}
@media screen and (min-width: 702px) and (max-width:767px){
  /* 顶部 */
.head{
  width: 100%;
  height: 253px;
  background-image: url('~@/assets/addMe_img/01871-crop-u7840.jpg');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.title{
  width: 500px;
  margin-left: 50px;
}
/* 位置 */
.location{
  width: auto;
  height: 27px;
  /* border: 1px red solid; */
  margin-top: -12%;
  margin-left: 14.5%;
  font-size: 12px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  width: 3%;
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 关于我们-导航 */
.lead{
  margin-left: 61%;
  margin-bottom: 0;
}
.lead ul{
  list-style: none;
}
.lead ul li{
  width: 25%;
  height: 20px;
  float: left;
  text-align: center;
  line-height: 20px;
}
.lead a{
  text-decoration: none;
  color: black;
  font-family: "黑体";
  font-size: 12px;
}
.lead_two{
  background-color: #F15A24;
}
/* 线 */
.line{
  width: 100%;
  height: 1px;
  background-color: black;
  margin-top: 20px;
}
/* 申请经销商 */
.agency{
  width: 55%;
  height: 620px;
  border: 1px black solid;
  margin: 0 auto;
  margin-top: 20px;
}
ul{
  list-style: none;
  margin-left: 5%;
}
.apply li{
  width: 90%;
  height: 70px;
  border-radius: 10px;
  border: 1px black solid;
  margin-top: 10px;
  font-size: 16px;
  color: rgb(158, 154, 154);
  line-height: 70px;
}
.applyFor{
  font-size: 20px;
  color: rgba(163, 8, 8, 0.829);
  margin-left: 5%;
}
.apply input{
  width: 70%;
  height: 50%;
  border: 0;
}
#business,#person{
  width: 3%;
  margin-left: 15%;
  display: inline-block;
  font-size: 20px;
  position: relative;
  top: 10px;
}
.agency-button{
  width: 20%;
  height: 50px;
  background-color: rgba(209, 13, 13, 0.884);
  color: white;
  font-size: 25px;
  margin-left: 40%;
  margin-top: 15px;
  /* box-shadow: none; */
  /* border: none; */
}
.agency textarea{
  width: 85%;
  margin-left: 5%;
  margin-top: 10px;
}
}
@media screen and (max-width:701px){
    .main{
    width: 100%;
    height: auto;
  }
      /* 顶部 */
.head{
  width: 100%;
  height: auto;
  background-image: url('~@/assets/addMe_img/01871-crop-u7840.jpg');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.title{
  width: 50%;
  margin-left: 30%;
  margin-top: 10px;
}
/* 位置 */
.location{
  width: auto;
  height: 20px;
  margin-top: 10px;
  margin-left: 10%;
  font-size: 12px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  width: 6%;
  display: inline-block;
}
.place{
  position: relative;
  left: 1.2%;
  top: -5px;
  cursor: pointer;
}
/* 关于我们-导航 */
.lead ul{
  list-style: none;
  margin-top: 20px;
  margin-left: 30%;
}
.lead ul li{
  width: 25%;
  height: 14px;
  float: left;
  text-align: center;
  line-height: 12px;
  /* margin-left: 10px; */
}
.lead a{
  text-decoration: none;
  color: black;
  font-family: "黑体";
  font-size: 12px;
}
.lead_two{
  background-color: #F15A24;
}
/* 线 */
.line{
  width: 100%;
  height: 1px;
  background-color: black;
  margin-top: 34px;
}
/* 申请经销商 */
.agency{
  width: 60%;
  height: 400px;
  border: 1px black solid;
  margin: 0 auto;
  margin-top: 20px;
}
ul{
  list-style: none;
  margin-left: 5%;
}
.apply li{
  width: 90%;
  height: 30px;
  border-radius: 10px;
  border: 1px black solid;
  margin-top: 10px;
  font-size: 12px;
  color: rgb(158, 154, 154);
  line-height: 30px;
}
.applyFor{
  font-size: 16px;
  color: rgba(163, 8, 8, 0.829);
  margin-left: 5%;
}
.apply input{
  width: 60%;
  height: 50%;
  border: 0px;
}
#business,#person{
  width: 3%;
  margin-left: 5%;
  display: inline-block;
  font-size: 20px;
  position: relative;
  top: 5px;
}
/* .apply textarea{
  border: 0;
} */
.agency-button{
  width: 30%;
  height: 30px;
  background-color: rgba(209, 13, 13, 0.884);
  color: white;
  font-size: 12px;
  margin-left: 35%;
  margin-top: 15px;
  /* box-shadow: none; */
  /* border: none; */
}
.agency textarea{
  width: 80%;
  margin-left: 6.3%;
  margin-top: 10px;
}
}

</style>



// WEBPACK FOOTER //
// src/components/addMe/agency.vue